import { createContext, useContext } from 'react';
const OfferingTypeContext = /*#__PURE__*/createContext('THEME');
export function useOfferingType() {
  return useContext(OfferingTypeContext);
}
export default OfferingTypeContext;